exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".existing-mappings-container .failed {\n  background-color: red;\n  padding: 4px;\n  color: azure;\n  font-weight: bold;\n  font-size: .8em;\n  width: 85px;\n  border-radius: 3px;\n  margin: 4px;\n}\n.existing-mappings-container .verified {\n  background-color: green;\n  padding: 4px;\n  color: azure;\n  font-weight: bold;\n  font-size: .8em;\n  width: 85px;\n  border-radius: 3px;\n  margin: 4px;\n}\n\n.actions-mappings-container{\n  margin-top: 2rem\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/integration-mappings/styles.css
// module id = 2109
// module chunks = 29